import { render, staticRenderFns } from "./productionLeft.vue?vue&type=template&id=396e791a&scoped=true&"
import script from "./productionLeft.vue?vue&type=script&lang=js&"
export * from "./productionLeft.vue?vue&type=script&lang=js&"
import style0 from "./productionLeft.vue?vue&type=style&index=0&id=396e791a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e791a",
  null
  
)

export default component.exports